import { createFileRoute, Outlet } from "@tanstack/react-router"
import * as z from "zod"

const searchSchema = z.object({
  siteId: z.string().optional(),
})

export const Route = createFileRoute("/_private/projects/$id/observations/new")({
  component: () => <Outlet />,
  validateSearch: (search) => searchSchema.parse(search),
})
